import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0d1f3c] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-14 pb-10">
        <div className="flex flex-col lg:flex-row gap-12 mb-12">

          {/* Brand Side */}
          <div className="w-full lg:w-[55%]">
            <img
              src="https://storage.readdy-site.link/project_files/f2e80cb9-6e9d-476e-b707-141660fae558/c191956b-eb38-4728-964c-f61cd28745ef_logo.png?v=ee2af49cd0d2ab77aa07359f00783dce"
              alt="ONOPTO 普像光学"
              className="h-20 w-auto object-contain mb-6"
            />
            <p className="text-white/60 text-sm leading-relaxed max-w-md">
              {t('footer.brand.desc')}
            </p>
          </div>

          {/* Contact Side */}
          <div className="w-full lg:w-[45%] flex flex-col sm:flex-row gap-10 items-start">

            {/* Email & Contact Info */}
            <div className="flex-1">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest">
                {t('footer.s4.title')}
              </h4>
              <div className="w-8 h-px bg-[#1B3F7A] mb-5" />
              <div className="flex flex-col gap-4">
                <a
                  href="mailto:info@onopto.com"
                  className="flex items-center gap-3 group"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 group-hover:bg-[#1B3F7A] transition-colors duration-200 flex-shrink-0">
                    <i className="ri-mail-line text-white/70 text-sm group-hover:text-white" />
                  </div>
                  <span className="text-white/65 text-sm group-hover:text-white transition-colors duration-200">
                    info@onopto.com
                  </span>
                </a>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 flex-shrink-0">
                    <i className="ri-time-line text-white/70 text-sm" />
                  </div>
                  <span className="text-white/55 text-sm">{t('contact.info2.value')}</span>
                </div>
              </div>
            </div>

            {/* WeChat QR Code */}
            <div className="flex-shrink-0">
              <p className="text-white/55 text-xs mb-3 uppercase tracking-widest">{t('footer.wechat.label')}</p>
              <div className="w-[108px] h-[108px] bg-white rounded-xl p-1.5 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/7f83c45d204e770ca4fa170af32d9e6f.png"
                  alt="ONOPTO 公众号二维码"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-white/40 text-xs mt-2 text-center">{t('footer.wechat.sub')}</p>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            {t('footer.bottom.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-white/40 hover:text-white/70 text-xs transition-colors whitespace-nowrap">{t('footer.bottom.privacy')}</a>
            <a href="#" rel="nofollow" className="text-white/40 hover:text-white/70 text-xs transition-colors whitespace-nowrap">{t('footer.bottom.terms')}</a>
            <a href="mailto:info@onopto.com" className="text-white/40 hover:text-white/70 text-xs transition-colors whitespace-nowrap">{t('footer.bottom.contact')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
